import { styled } from '@mui/material/styles';
import { tannerGray, tannerBlack } from '../ThemeProvider/colors';
import TextField from '../TextField';

export const StyledTextField = styled(TextField)({
  '> div': {
    input: {
      paddingRight: '28px',
    },
  },
  svg: {
    transition: 'color .2s',
  },
  '&:hover, &:focus-within': {
    svg: {
      color: tannerBlack,
    },
  },
});

export const InputAdornmentStyles = {
  svg: {
    color: tannerGray['600'],
  },
};

export const PaperStyles = {
  marginTop: '4px',
  '& .MuiPickersCalendarHeader-root, .MuiIconButton-root .MuiSvgIcon-root': {
    color: tannerGray['600'],
  },
  '& .MuiPickersCalendarHeader-label': {
    marginLeft: '6px',
    marginRight: '2px',
  },
  '& .MuiPickersArrowSwitcher-root': {
    fontSize: '1rem',
  },
  '& .MuiPickersCalendarHeader-labelContainer': {
    fontSize: '1rem',
    fontWeight: '700',
  },
  '& .MuiPickersCalendarHeader-root': {
    paddingLeft: '16px',
    paddingRight: '11px',
  },
  '& .MuiPickersDay-root, .MuiTypography-caption': {
    width: '40px',
    height: '40px',
  },
  '& .MuiDayPicker-slideTransition': {
    minHeight: '220px',
  },
  '& .MuiPickersToolbar-root': {
    padding: '24px 24px 0 24px',

    '& .MuiTypography-overline, .MuiIconButton-root': {
      display: 'none',
    },
    '& .MuiDatePickerToolbar-title': {
      padding: '0',
      margin: '0',
    },
    '& .MuiPickersToolbar-content': {
      margin: '0',
    },
  },
  '& .MuiDialogActions-root  button:first-of-type': {
    backgroundColor: tannerGray[200],
    color: tannerBlack,
  },
  '& .MuiCalendarOrClockPicker-root': {
    flexDirection: 'column',
  },
};

export const DateRangeTextField = {
  '& .MuiInputBase-root': {
    paddingRight: '16px',
    svg: {
      width: '12px',
      height: '13.5px',
      margin: '4px',
    },
    '.closeIcon': {
      marginRight: '12px',
      cursor: 'pointer',
    },
  },
  '& .MuiInputBase-input': {
    paddingRight: '8px',
  },
  '& .Mui-readOnly': {
    svg: {
      color: tannerGray[300],
      width: '12px',
      height: '13.5px',
    },
  },
  '.calendarEndIcons': {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
};

export const DateRangeFieldSelector = {
  p: {
    paddingLeft: '4px',
    paddingRight: '4px',
    color: tannerGray[500],
  },
};

export const DateRangeLayout = {
  '& .MuiDateRangePickerToolbar-container': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiTypography-h5': {
    fontWeight: 'bold',
    display: 'flex',
  },
  '& .MuiPickersCalendarHeader-label': {
    color: tannerGray[500],
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '800',
    lineHeight: '150%',
  },
};

export const MobilePaperStyles = {
  '& .MuiDialogActions-root  button:first-of-type': {
    backgroundColor: tannerGray[200],
    color: tannerBlack,
  },
};

export const DateRangePickerFieldStyles = {
  sx: {
    alignItems: 'center',
  },
};
